<template>
  <div v-if="isActive">
    <OnboardingWelcomeModal :show="showWelcome" />
    <OnboardingChecklist v-if="showChecklist" />
  </div>
</template>

<script setup lang="ts">
import OnboardingWelcomeModal from '~/components/serviceprovider/onboarding/OnboardingWelcomeModal.vue'
import OnboardingChecklist from '~/components/serviceprovider/onboarding/OnboardingChecklist.vue'

const { isActive, showChecklist, showWelcome, load, refreshStatus } = useOnboarding()
const route = useRoute()

onMounted(() => { load() })

// steps like "NFR-Domäne anlegen" are completed on other pages, re-check when navigating
watch(() => route.path, () => {
  if (isActive.value) {
    refreshStatus()
  }
})
</script>
